import { render, staticRenderFns } from "./Comunicate.vue?vue&type=template&id=223de16a&"
import script from "./Comunicate.vue?vue&type=script&lang=js&"
export * from "./Comunicate.vue?vue&type=script&lang=js&"
import style0 from "./Comunicate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports